import { ObservableArray, View } from "binder"
import { TypeSelectorViewModel } from "../typeSelector/typeSelector-viewModel";
import { MethodBodyManipulatorViewModel } from "./methodBody/methodBodyManipulator/methodBodyManipulator-viewModel";
import { inputParameter, MethodManipulationViewModel } from "./methodManipulation-viewModel"

export class MethodManipulationView extends View<MethodManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-3B28B1BD-0540-4A81-A6FF-A23579C07AA4"
    }
    loadHtml(): string {
        let element = require('./methodManipulation.html').default;
        let style = require('./methodManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isAsync(v: boolean) { this._isAsync = v; } public get isAsync(): boolean { return this._isAsync;} private _isAsync: boolean;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set inputParameters(v: ObservableArray<inputParameter>) { this._inputParameters = v; } public get inputParameters(): ObservableArray<inputParameter> { return this._inputParameters;} private _inputParameters: ObservableArray<inputParameter>;
    public set returnType(v: TypeSelectorViewModel) { this._returnType = v; } public get returnType(): TypeSelectorViewModel { return this._returnType;} private _returnType: TypeSelectorViewModel;
    public set methodBodyManipulator(v: MethodBodyManipulatorViewModel) { this._methodBodyManipulator = v; } public get methodBodyManipulator(): MethodBodyManipulatorViewModel { return this._methodBodyManipulator;} private _methodBodyManipulator: MethodBodyManipulatorViewModel;

    confirm(){
        this.dataContext.confirm();
    }

    back(){
        this.dataContext.back();
    }

    addNewArgument(){
        this.dataContext.addNewArgument();
    }
}
